var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('router-link',{staticClass:"ruta",attrs:{"to":{name: 'revista'}}},[_c('img',{staticClass:"w-100",attrs:{"src":require("@/assets/images/banner.jpg"),"alt":""}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }